module.exports = require('./srv-failover.coffee');



//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 191
// module chunks = 0